import {
  Box,
  Button,
  Flex,
  Grid,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  Center,
  Image,
  ModalBody,
  ModalFooter,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useColorModeValue,
  Input,
  InputGroup,
  InputLeftElement,
  TableContainer,
  Spinner,
} from "@chakra-ui/react";
import { createColumnHelper } from "@tanstack/react-table";
import { CiCircleCheck } from "react-icons/ci";
// Custom components
import { SearchIcon } from "@chakra-ui/icons";

import Card from "components/Card/Card";
import { BsPencil } from "react-icons/bs";
import "./TableUser.css";
import * as React from "react";
// Assets

import useUser from "hooks/use-user";
import AddUserModal from "components/User/Create";
import { MdDisabledByDefault } from "react-icons/md";
import UpdateUserModal from "components/User/Update";
import LoadingComponent from "components/Main/Loading";
type RowObj = {
  id: number;
  storeId: number;
  receivingSectorId: number;
  beginDate: string;
  endDate: string;
  userId: any;
  updatedAt: string;
  storeDescription: string;
  receivingSectorDescription: string;
};

const columnHelper = createColumnHelper<RowObj>();

// const columns = columnsDataCheck;
export default function Ursers(props: { tableData: any }) {
  const {
    data,
    getData,
    isFirstData,
    deleteData,
    loading,
    loadingGeneral,
    pageCurrent,
    total,
    getDataById,
  } = useUser();
  let totalPages = total / 20;
  let page = 1;

  const searchIconColor = useColorModeValue("gray.700", "white");
  const inputBg = useColorModeValue("secondaryGray.300", "navy.900");
  const inputText = useColorModeValue("gray.700", "gray.100");
  const textTable = useColorModeValue("black", "white");
  const textColorInvert = useColorModeValue("black", "black");

  const searchRef = React.useRef("");
  const timerRef = React.useRef<NodeJS.Timeout | undefined>();

  const isMobile = useBreakpointValue({ base: true, md: false });
  const [search, setSearch] = React.useState("");

  const [idSelect, setIdSelect] = React.useState("");
  const [isOpenDeleted, setIsOpenDelete] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const [typeActive, setStypeActive] = React.useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  const scrollRef = React.useRef(null);

  const handleCloseDelete = () => {
    setIsOpenDelete(false);
  };

  const handleOpenDelete = () => {
    setIsOpenDelete(true);
  };
  const handleDelete = React.useCallback(() => {
    deleteData(Number(idSelect));
    handleCloseDelete();
  }, [deleteData, idSelect]);

  const handleUpdate = React.useCallback(
    (id: any, obj: any) => {
      getDataById(Number(id), obj);
      setIsOpen(true);
    },
    [getDataById, idSelect]
  );
  React.useEffect(() => {
    const handleScroll = () => {
      const container = scrollRef.current;
      if (
        container &&
        container.scrollTop + container.clientHeight >=
          container.scrollHeight - 1 &&
        !loading
      ) {
        if (page <= totalPages) {
          page++;
          getData("", pageCurrent + 1, 20);
        }
      }
    };

    scrollRef.current?.addEventListener("scroll", handleScroll);
    return () => {
      scrollRef.current?.removeEventListener("scroll", handleScroll);
    };
  }, [getData, loading, page, pageCurrent, totalPages]);

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
    searchRef.current = event.target.value;
  };

  React.useEffect(() => {
    isFirstData && getData("", 1, 20);
    if (!isFirstData) {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        getData(search, pageCurrent, 20);
      }, 500);
    }
  }, [search]);
  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <UpdateUserModal isOpen={isOpen} onClose={handleClose} id={idSelect} />
      <Flex px="25px" mb="8px" justifyContent="space-between" align="center">
        <InputGroup w={{ base: "100%", md: "200px" }}>
          <InputLeftElement
            children={
              <IconButton
                aria-label="search"
                bg="inherit"
                borderRadius="inherit"
                _active={{
                  bg: "inherit",
                  transform: "none",
                  borderColor: "transparent",
                }}
                _focus={{
                  boxShadow: "none",
                }}
                icon={<SearchIcon color={searchIconColor} w="15px" h="15px" />}
              />
            }
          />
          <Input
            variant="search"
            fontSize="sm"
            bg={inputBg}
            color={inputText}
            fontWeight="500"
            _placeholder={{ color: "gray.400", fontSize: "14px" }}
            borderRadius={"30px"}
            placeholder={"Pesquisar"}
            onChange={handleSearch}
            value={search}
          />
        </InputGroup>
        {/* <Menu /> */}
        <Stack direction={{ base: "column", md: "row" }} spacing="34px" p={6}>
          <AddUserModal />
        </Stack>
      </Flex>
      <Modal isOpen={isOpenDeleted} onClose={handleCloseDelete}>
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <Center>
              <Image
                width="80%"
                src="https://cdn.dribbble.com/users/1020708/screenshots/2603107/015_dribbble.gif"
              />
            </Center>

            <Center>
              <h1>
                {typeActive
                  ? "Deseja realmente desativar esse registro?"
                  : "Deseja realmente reativar esse registro?"}
              </h1>
            </Center>
          </ModalBody>
          <ModalFooter>
            <Flex justifyContent="center" width="100%">
              <Button variant="ghost" onClick={handleCloseDelete}>
                Cancelar
              </Button>
              <Button
                colorScheme={typeActive ? "red" : "green"}
                mr={3}
                onClick={handleDelete}
              >
                {typeActive ? "Desativar" : "Ativar"}
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Flex justify="flex-end"></Flex>
      {loadingGeneral && isFirstData ? (
        <>
          <LoadingComponent spinnerSize="50vh" />
        </>
      ) : (
        <>
          {!isMobile ? (
            // Exibir os cards em versões mobile

            <Box overflow="auto" ref={scrollRef} height="450px">
              <Box>
                <TableContainer>
                  <Table
                    className="custom-table"
                    color="gray.500"
                    mb="24px"
                    mt="12px"
                  >
                    <Thead
                      style={{
                        position: "sticky",
                        top: 0,
                      }}
                    >
                      <Tr bg="gray.100">
                        <Th color={textColorInvert}>Status</Th>
                        <Th color={textColorInvert}>Nome</Th>
                        <Th color={textColorInvert}>Email</Th>
                        <Th color={textColorInvert}>Fornecedor</Th>
                        <Th color={textColorInvert}>Ações</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {data.map((item) => (
                        <Tr>
                          <Td scope="row" color={textTable}>
                            <Flex color={textTable}>
                              <Box
                                ml={2}
                                w="10px"
                                h="10px"
                                bg={item.isActive ? "green.500" : "red.500"}
                                borderRadius="50%"
                                mt={1}
                                mr={2}
                                color={textTable}
                              />
                              {item.isActive ? "Sim" : "Não"}
                            </Flex>
                          </Td>
                          <Td color={textTable} textAlign="center">
                            {item.name}
                          </Td>
                          <Td color={textTable} textAlign="center">
                            {item.email}
                          </Td>
                          <Td color={textTable} textAlign="center">
                            {item.description}
                          </Td>

                          <Td>
                            <Center>
                              <IconButton
                                icon={
                                  item.isActive ? (
                                    <MdDisabledByDefault />
                                  ) : (
                                    <CiCircleCheck />
                                  )
                                }
                                aria-label="Excluir"
                                variant="outline"
                                size="sm"
                                colorScheme={item.isActive ? "red" : "green"}
                                cursor="pointer"
                                onClick={() => {
                                  setIdSelect(item.id);
                                  setStypeActive(item.isActive);
                                  handleOpenDelete();
                                }}
                              />
                              <IconButton
                                ml={2}
                                icon={<BsPencil />}
                                aria-label="Editar"
                                variant="outline"
                                size="sm"
                                colorScheme="teal"
                                onClick={() => {
                                  setIdSelect(item.id);
                                  handleUpdate(item.id, item);
                                }}
                              />
                            </Center>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
              {loadingGeneral && (
                <>
                  <Center>
                    <Spinner />
                  </Center>
                </>
              )}
            </Box>
          ) : (
            // Exibir a tabela em versões desktop
            <Grid
              templateColumns="repeat(auto-fit, minmax(200px, 1fr))"
              gap={4}
              p={4}
            >
              {data.map((item) => (
                <Flex key={item.code} direction="row" ref={scrollRef}>
                  <Box
                    borderWidth="3px"
                    borderRadius="md"
                    p={4}
                    boxShadow="base"
                    _hover={{ boxShadow: "xl" }}
                    flex="1"
                  >
                    <Stack spacing={2}>
                      <Box as="strong">
                        <Flex>
                          <Box
                            mt={2}
                            w="10px"
                            h="10px"
                            bg={item.isActive ? "green.500" : "red.500"}
                            borderRadius="50%"
                          />
                          <Text ml={2}>
                            {" "}
                            {item.isActive ? "Ativo" : "Desativado"}
                          </Text>
                        </Flex>
                      </Box>
                      <Box>{item.name}</Box>
                      <Box>{item.email}</Box>
                      <Box>{item.description}</Box>
                      <hr></hr>
                      <Flex justifyContent="space-between" alignItems="center">
                        <Flex>
                          <Box pr={3}>
                            <IconButton
                              icon={<MdDisabledByDefault />}
                              aria-label="Excluir"
                              variant="outline"
                              size="sm"
                              colorScheme="red"
                              onClick={() => {
                                setIdSelect(item.id);
                                handleOpenDelete();
                              }}
                            />
                          </Box>

                          <IconButton
                            icon={<BsPencil />}
                            aria-label="Editar"
                            variant="outline"
                            size="sm"
                            colorScheme="teal"
                            onClick={() => {
                              setIdSelect(item.id);
                              handleUpdate(item.id, item);
                            }}
                          />
                        </Flex>
                      </Flex>
                    </Stack>
                  </Box>
                </Flex>
              ))}
            </Grid>
          )}
        </>
      )}
    </Card>
  );
}
